import React, { useEffect, useState, useContext}  from 'react';
import { ThemeContext, ConstantsContext } from "../index";
import { NumericFormat } from 'react-number-format';
import {numberToAmericanFormat, roundDecimals} from './functions';

export default function CoingeckoCurrentCoinPriceWarning(props) {

  const [theme] = useContext(ThemeContext);

  let priceWarning = '';

    if(props.action == 'buy_limit') {

      priceWarning = 'max value: '
    }
    else if(props.action == 'buy_stop_limit') {

      priceWarning = 'max value: '
    }
    else if(props.action == 'sell_short') {

        priceWarning = 'max value: '
      }

  return (
    <>
        {props.cash_total_balance_available > 0 ?
            <div style={{fontSize:10}}>
                <span>{priceWarning}</span>
                <span>
                <NumericFormat
                    className={`input_${theme.btn_color == '#C7E7FA' ? 'dark' : 'light'}`}
                    displayType="text"
                    value={props.action == 'sell_short' ? Math.abs(props.cash_total_balance_available) - Math.abs(props.shortSellTotal) : props.cash_total_balance_available} 
                    thousandSeparator="," 
                    allowNegative={false} 
                    decimalScale={8}
                    prefix={`$`} 
                    renderText={(value) => <>{value}</>}
                />
                </span>
            </div>
        :
            <div style={{fontSize:10}}>insufficient balance</div>
        }
    </>
  );
}